import { AnyAction, Reducer, applyMiddleware, combineReducers, compose, createStore } from 'redux'
import { persistCombineReducers, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { DeepPartial } from 'utility-types'
import { FetchAdapter } from '@cbgms/base/http'
import { USER_LOGOUT } from 'app-support/auth/state/types'
import httpMiddleware from 'middlewares/http'
import { handle } from 'middlewares/errorHandler'
import reducers, { IRootReducerState } from './reducers'

const persistConfig = {
  key: 'cs:support_application',
  storage,
  whitelist: ['auth', 'region']
}

const rootReducer = (appReducer: Reducer<IRootReducerState, AnyAction>) => (state: IRootReducerState | undefined, action: AnyAction) => {
  const nextState =
    action.type === USER_LOGOUT && state && state.auth
      ? {
          ...state,
          auth: {
            urls: {
              ...state.auth.urls
            }
          } as any
        }
      : state

  return appReducer(nextState, action)
}
export const finalReducer = rootReducer(combineReducers<IRootReducerState>(reducers))

const getFetchAdapters = (baseURL?: string) => {
  return {
    support: new FetchAdapter(baseURL)
  }
}

const createFakePersistor = () => {
  return {
    pause: () => {},
    persist: () => {},
    purge: async () => {},
    flush: async () => {},
    dispatch: (_: any) => ({} as any),
    getState: () => ({} as any),
    subscribe: (_: any) => () => ({} as any)
  }
}
export const configureStore = (
  env: string,
  preloadedState?: DeepPartial<IRootReducerState>,
  options?: { devTools?: any; shouldPersist?: boolean }
) => {
  const fetchAdapters = getFetchAdapters(preloadedState?.auth?.urls?.support)
  const middlewares = [httpMiddleware(fetchAdapters, handle)]

  const combinedReducers = persistCombineReducers<IRootReducerState>(persistConfig, reducers) as any as Reducer<
    IRootReducerState,
    AnyAction
  >

  const enhancers =
    env !== 'development' || !options?.devTools
      ? applyMiddleware(...middlewares)
      : compose(applyMiddleware(...middlewares), options?.devTools())

  const store = createStore(rootReducer(combinedReducers), preloadedState as IRootReducerState, enhancers)

  let persistor = createFakePersistor()
  if (options?.shouldPersist) {
    persistor = persistStore(store)
  }

  return { persistor, store }
}

export const { store, persistor } = configureStore(process.env.NODE_ENV || 'development', undefined, {
  devTools: (window as any)['__REDUX_DEVTOOLS_EXTENSION__'],
  shouldPersist: true
})
